import {
  CarrotPlanFormSelectOption,
  CarrotPlanFormOption,
  MenuItemOptionFields,
  MediaOptionFields,
  FormResponsiveDisplayStatus,
  TopicOptionFields
} from "./hooks/useCarrotPlanMappings"
import { DisplayStatus } from "types/CarrotPlanOptions"

export const HAS_ANSWERED_MEDICAL_QUESTIONS_MSG =
  "This member already answered medical questions. Make sure you want to include this item"
export const RESTRICTED_MSG = "Based on what we know about the member, this option is not available"
export const DUPLICATE_MSG = "You can't include the same item twice in one Carrot Plan"
export const EXISTS_PRIOR_MSG = "This item appeared in a previous Carrot Plan. Make sure you want to include it again."
export const RECOMMENDED_MSG = "Recommended item based on member's responses"
export const REQUESTED_MSG = "Requested item based on the member's interests"
export const REQUIRED_BY_GREGBOT_HELPER_TEXT = "Required by Gregbot."
export const REQUIRED_BY_GREGBOT_PREFIX = "Required by Gregbot. "

export type SelectOption = CarrotPlanFormOption<MenuItemOptionFields | TopicOptionFields | MediaOptionFields>

export function getDisabledOrWarningMessage(option: CarrotPlanFormSelectOption): string {
  const displayStatus = option?.optionMetadata?.displayStatus
  switch (displayStatus) {
    case FormResponsiveDisplayStatus.DUPLICATE_ON_SAME_PLAN:
      return DUPLICATE_MSG
    case DisplayStatus.WARNING_ON_PREVIOUS_CARROT_PLAN:
      return EXISTS_PRIOR_MSG
    case DisplayStatus.WARNING_ALREADY_ANSWERED_MEDICAL_QUESTIONS:
      return HAS_ANSWERED_MEDICAL_QUESTIONS_MSG
    case DisplayStatus.DISABLE:
      return RESTRICTED_MSG
    default:
      return ""
  }
}

export function getRecommendedMessage(option: CarrotPlanFormSelectOption): string {
  if (option?.optionMetadata?.isRecommended) {
    return RECOMMENDED_MSG
  }
  return ""
}

/**
 * Caption for items loaded from the recommendations engine, identified by the
 * top-level `tier` field on the option (set by `buildRecommendedSteps`). Only
 * the "Requested" tier surfaces a caption; other tiers intentionally show nothing.
 */
export function getRecommendationsTierMessage(option: CarrotPlanFormSelectOption): string {
  if (option?.tier === "Requested") return REQUESTED_MSG
  return ""
}

export function isMandatory(
  optionMetadata: { isRequired?: boolean; isPrioritized?: boolean } | null | undefined
): boolean {
  return optionMetadata?.isRequired === true || optionMetadata?.isPrioritized === true
}

export function getCaptionText(option: SelectOption | undefined): string {
  if (!option) return ""
  if (isMandatory(option.optionMetadata)) return REQUIRED_BY_GREGBOT_HELPER_TEXT
  // Rec-loaded options carry a top-level `tier`; they follow rec-specific caption
  // logic and do NOT fall through to the legacy isRecommended caption.
  if (option.tier != null) {
    return getDisabledOrWarningMessage(option) || getRecommendationsTierMessage(option) || ""
  }
  return getDisabledOrWarningMessage(option) || getRecommendedMessage(option) || ""
}
